import React from 'react';
import { Container, Typography } from '@mui/material';

export default function ConnectionDesign() {
  return (
    <Container sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>Steel Connection Design</Typography>
      <Typography>Module coming soon...</Typography>
    </Container>
  );
} 